interface HDECountryEvent {
    Country?: string | null;
    RegistrationStatus?: string | null;
}

const normaliseCountryCode = (countryCode: string): string =>
    countryCode.trim().toUpperCase();

/**
 * Legacy HDE rows without a Country are NZ events.
 */
export const isHDEEventInCountry = (
    event: HDECountryEvent,
    countryCode: string,
): boolean => {
    const currentCountryCode = normaliseCountryCode(countryCode);
    const eventCountry = normaliseCountryCode(event.Country ?? '');

    if (eventCountry === currentCountryCode) {
        return true;
    }

    return currentCountryCode === 'NZ' && eventCountry === '';
};

/**
 * Active HDE events are the source of truth for showing market-specific HDE surfaces.
 */
export const isActiveHDEEventInCountry = (
    event: HDECountryEvent,
    countryCode: string,
): boolean => {
    return (
        event.RegistrationStatus === 'active' &&
        isHDEEventInCountry(event, countryCode)
    );
};

export const hasActiveHDEEventInCountry = (
    events: HDECountryEvent[],
    countryCode: string,
): boolean => {
    return events.some((event) =>
        isActiveHDEEventInCountry(event, countryCode),
    );
};

/**
 * HDE is no longer market-disabled in code; availability follows active EventDetails rows.
 */
export const isHDEUnavailableInCountry = (_countryCode: string): boolean => {
    return false;
};
